import { ProgressBar } from '@intelie/ui'
import { Modal } from 'react-bootstrap'
import styled from 'styled-components'

export const ImportBody = styled.div`
    font-size: 14px;
`
export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 16px;
`

export const ImportFooter = styled(Modal.Footer)`
    .importLabel {
        font-size: 15px;
        cursor: pointer;
        color: var(--gray-0);

        padding: 8px 12px;

        .file-input {
            display: none;
        }
    }

    .btn.btn-primary {
        &.no-pad {
            padding: 0;
        }
    }
`
export const ProgressBarContentContainer = styled.div<{ color: string }>`
    font-size: 13px;
    line-height: 16px;
    .pbar-first-row {
        font-family: var(--font-semibold);
    }

    .pbar-bar-bundle {
        display: flex;
        align-items: center;
        gap: 8px;
        color: ${({ color }) => color};
        font-family: var(--font-semibold);
        .pbar-counter {
            white-space: nowrap;
        }

        span {
            background: ${({ color }) => color};
        }
    }

    .pbar-entities-loaded {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;
        font-size: 16px;
        line-height: 19px;
        font-family: var(--font-semibold);
    }

    .pbar-last-row {
        padding-left: 21px;
    }
`

export const StyledProgressBar = styled(ProgressBar)``
